import {z} from 'zod';
import {Date} from './../models/date';

export const UserInfo = z.object({
  lastLogin: Date.nullable(),
  addressVerificationRequired: z.boolean(),
  versionTermsOfUse: z.string().nullable(),
  email: z.string(),
  salutation: z.string(),
  lastName: z.string(),
  onlinedeal: z.number().nullable(),
  onlinedealStatus: z.number(),
  roles: z.array(z.string()),
  firstName: z.string(),
  personExistedInTobias: z.boolean()
});

export type UserInfo = z.infer<typeof UserInfo>;
